import { render, staticRenderFns } from "./SpecialRequestDialog.vue?vue&type=template&id=0aaac308&scoped=true"
import script from "./SpecialRequestDialog.vue?vue&type=script&lang=ts"
export * from "./SpecialRequestDialog.vue?vue&type=script&lang=ts"
import style0 from "./SpecialRequestDialog.vue?vue&type=style&index=0&id=0aaac308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaac308",
  null
  
)

export default component.exports